import { GrSearch } from "react-icons/gr";
import { IoMdClose } from "react-icons/io";

const InputBox = ({
  handleClearClick,
  handleInputChange,
  search,
  keyword,
  placeholder = "검색어를 입력해주세요",
  color,
}) => {
  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      search();
    }
  };
  const handleOnClick = (e) => {
    search();
  };

  return (
    <label
      className={`flex items-center gap-2 bg-white input input-bordered border-${color} `}
    >
      <input
        type="text"
        className="w-full font-semibold leading-7 grow placeholder:text-neutral-400"
        placeholder={placeholder}
        value={keyword} // 여기서 초기값이 undefined가 아니라 빈 문자열로 설정됩니다.
        onChange={handleInputChange}
        // onKeyDown={handleKeyPress}
      />

      {keyword && (
        <button
          className="flex items-center justify-center rounded-full w-7 h-7 bg-neutral-50"
          onClick={handleClearClick}
        >
          <IoMdClose style={{ color: "#A3A3A3" }} />
        </button>
      )}

      <button
        className="flex items-center justify-center rounded-full w-7 h-7 "
        // onClick={handleOnClick}
      >
        <GrSearch className="text-2xl" />
      </button>
    </label>
  );
};

export default InputBox;
